import { render } from "./AdmissionView.vue?vue&type=template&id=5cdda953"
import script from "./AdmissionView.vue?vue&type=script&lang=js"
export * from "./AdmissionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__